import { useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  CircularProgress,
  Grid,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

import { formatPrice } from "../../../utils/function";

import ReceiptDetail from "./ReceiptDetail";

export default function ReceiptsTable({ title, loading, items }) {
  const [rowsExpanded, setRowsExpanded] = useState([]);
  const columns = [
    {
      name: "RECEIPTS_ID",
      label: "ID",
    },
    {
      name: "DESCRIPTION",
      label: "Title",
    },
    {
      name: "COMMENTS",
      label: "Description",
    },
    {
      name: "COST",
      label: "Cost",
      options: {
        customBodyRender: (value, tableMeta) => {
          return formatPrice(value);
        },
      },
    },
    {
      name: "USERNAME",
      label: "Username",
    },
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
    expandableRows: true,
    rowsExpanded: rowsExpanded,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const rowIndex = rowMeta.rowIndex;
      const colSpan = rowData.length + 1;
      const selectedRow = items[rowIndex];
      console.log(selectedRow);

      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <Grid container alignItems="center" spacing={4}>
              <Grid item xs={12}>
                <ReceiptDetail data={selectedRow} />
              </Grid>
            </Grid>
          </TableCell>
        </TableRow>
      );
    },
  };

  const handleRowExpandToggle = (rowData) => {
    const expandedRowIndex = rowsExpanded.indexOf(rowData.index);

    if (expandedRowIndex === -1) {
      // Row is currently not expanded, so add it to the rowsExpanded array
      setRowsExpanded([...rowsExpanded, rowData.index]);
    } else {
      // Row is currently expanded, so remove it from the rowsExpanded array
      setRowsExpanded(rowsExpanded.filter((index) => index !== rowData.index));
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <MUIDataTable
          title={
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <Typography variant="h5">{title}</Typography>
              </Grid>
              {loading && (
                <Grid item>
                  <CircularProgress size="1rem" />
                </Grid>
              )}
            </Grid>
          }
          data={items}
          columns={columns}
          options={options}
          onRowExpansionChange={handleRowExpandToggle}
        />
      </Grid>
    </Grid>
  );
}
